import type { ReactNode } from 'react';

export const symbol_dialogs: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M294-264h372q12.75 0 21.38-8.63Q696-281.25 696-294v-372q0-12.75-8.62-21.38Q678.75-696 666-696H294q-12.75 0-21.37 8.62Q264-678.75 264-666v372q0 12.75 8.63 21.37Q281.25-264 294-264ZM180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm0-60h600v-600H180v600Zm0-600v600-600Z"
		/>
	</svg>
);
